import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../components/Reservar.css";
import { screenActions } from "../store/screens-slice";
import { dataActions } from "../store/data-slice";
import PopPop from "react-poppop";
import { formatDate } from "../helpers/formatDate";
import "../components/Resumen.css";
import { useTranslation } from "react-i18next";
import "../components/ErrorScreen.css";
import ClipLoader from "react-spinners/ClipLoader";

const Reservar = () => {
  const [t, i18n] = useTranslation("global");
  const { language } = i18n;
  const dispatch = useDispatch();

  const [data, setData] = useState({
    email: "",
    phone: "",
    name: "",
    userNif: "",
    observations: "",
  });

  const [errorEmail, setErrorEmail] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [errorName, setErrorName] = useState("");
  const [errorUserNif, setErrorUserNif] = useState("");

  const [pagadoChecked, setPagadoChecked] = useState(false);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(true);

  const salidas = useSelector((state) => state.data.salidas);

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    searchParams.forEach((value, key) => {
      if (key === "paid") {
        setPagadoChecked(true);
      } else {
        setData((prevState) => ({
          ...prevState,
          [key]: value,
        }));
      }
    });
  }, []);

  const handleBackScreen = () => {
    dispatch(screenActions.setMainScreen("practicas"));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let errors = validateData();

    if (errors) {
      console.error(errors);
      return;
    }
    setShow(true);

    sendData();
  };

  const validateData = () => {
    let errors = false;
    if (!data.email) {
      setErrorEmail(t("RESERVAR.form.error.email"));
      errors = true;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(data.email)) {
      setErrorEmail(t("RESERVAR.form.error.email_invalid"));
      errors = true;
    }
    if (!data.phone) {
      setErrorPhone(t("RESERVAR.form.error.phone"));
      errors = true;
    } else if (
      !/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(data.phone)
    ) {
      setErrorPhone(t("RESERVAR.form.error.phone_invalid"));
      errors = true;
    }
    if (!data.name) {
      setErrorName(t("RESERVAR.form.error.name"));
      errors = true;
    }
    if (!data.userNif) {
      setErrorUserNif(t("RESERVAR.form.error.nif"));
      errors = true;
    }

    return errors;
  };

  const sendData = async () => {
    const environment = process.env.REACT_APP_ENVIRONMENT;
    let domain =
      environment === "development"
        ? "http://localhost:7000"
        : "https://reservas.escolaportbarcelona.com/api";

    const ids = salidas.map((s) => s.id).join(";");
    const pracod = salidas.map((s) => s.data.pracod).join(";");
    const plazas = salidas.map((s) => s.personas).join(";");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        nombre: data.name,
        correo: data.email,
        nif: data.userNif,
        telefono: data.phone,
        observaciones: data.observations,
        pracid: ids,
        pracod,
        plazas,
      }),
    };

    try {
      const res = await fetch(
        `${domain}/add_inscripcion_salida_club`,
        requestOptions
      );
      let { status } = res;

      const data = await res.text();
      await new Promise((resolve) => setTimeout(resolve, 3000));

      setLoader(false);

      if (status === 200) {
        setTimeout(() => {
          setShow(false);
          window.location.reload();
        }, 4000);
      } else if (status === 400) {
        if (data.trim() === "Hay datos vacíos") {
          dispatch(screenActions.setMainScreen("errorscreen"));

          dispatch(
            dataActions.fetchingInfo({
              fetchingCode: 400,
              codeId: 1,
            })
          );
        } else {
          dispatch(
            dataActions.fetchingInfo({
              fetchingCode: 400,
              codeId: 2,
            })
          );
        }
      } else {
        dispatch(screenActions.setMainScreen("errorscreen"));
      }
    } catch (e) {
      console.error(e);
      await new Promise((resolve) => setTimeout(resolve, 3000));

      dispatch(screenActions.setMainScreen("errorscreen"));
    }
  };

  const Popup = () => {
    return (
      <>
        <PopPop
          position="centerCenter"
          open={show}
          closeBtn={true}
          closeOnEsc={true}
          onClose={() => {
            window.location.reload();
          }}
          closeOnOverlay={true}
          contentStyle={{
            backgroundColor: "#E1E1E1",
            overflow: "hidden",
            padding: 20,
          }}
        >
          {loader ? (
            <>
              <div className="reservar__loadingContainer">
                <ClipLoader color="#499bb1" loading={true} size={60} />
                <div className="reservar__datos">
                  <p>{t("RESERVAR.popup.sending")}</p>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="resumen__logoContainer">
                <div className="success-animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>
              </div>
              <div className="resumen__popupParag">
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("RESERVAR.popup.success"),
                  }}
                />
              </div>
            </>
          )}
        </PopPop>
      </>
    );
  };

  const renderPayment = () => {
    return (
      <div className="reservar__infoContainer">
        <h3>{t("RESERVAR.subtitle")}</h3>
        <div className="reservar__pagarContainer">
          <div className="reservar__checkbox">
            {t("RESERVAR.already_paid")}
            <input
              type="checkbox"
              id="pagar"
              onClick={() => setPagadoChecked(!pagadoChecked)}
            />
          </div>
          <div className="reservar__pagar">
            <button
              disabled={pagadoChecked}
              type="button"
              onClick={() => {
                window.open(
                  "https://ofertesnautiques.com/barcelona/practicas/club-de-navegacion/",
                  "_blank"
                );
              }}
            >
              {t("RESERVAR.pay_now")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container reservar__container">
      <Popup />

      <h2>{t("RESERVAR.title")}</h2>
      {!pagadoChecked && renderPayment()}
      <div className="reservar__reservaDetails ">
        {salidas.map((s, index) => {
          return (
            <div key={index} style={{ textAlign: "left" }}>
              {s.data.modalidad == "Regatas"
                ? t("ELEMENT.cursos.regatas").toUpperCase()
                : s.data.modalidad === "Curso Vela Básico"
                ? t("ELEMENT.cursos.vela").toUpperCase()
                : s.data.modalidad}{" "}
              | {formatDate(s.data.fecha)} | {s.data.horario[0]} a{" "}
              {s.data.horario[1]} x{s.personas}
            </div>
          );
        })}
      </div>

      <div className="reservar__inputsContainer">
        <form onSubmit={handleSubmit}>
          <div>
            <div>
              <label htmlFor="email">{t("RESERVAR.form.label.email")}</label>
              <input
                className={`${errorEmail && "input-danger"}`}
                type="text"
                name="correo"
                placeholder={t("RESERVAR.form.placeholder.email")}
                onChange={(e) => {
                  setData({ ...data, email: e.target.value });
                  setErrorEmail(false);
                }}
                value={data.email || ""}
              />
              {errorEmail && <p className="p-danger pb-4">{errorEmail}</p>}
            </div>
            <div>
              <label htmlFor="Phone">{t("RESERVAR.form.label.phone")}</label>
              <input
                className={`${errorPhone && "input-danger"}`}
                type="text"
                name="telefono"
                placeholder={t("RESERVAR.form.placeholder.phone")}
                onChange={(e) => {
                  setData({ ...data, phone: e.target.value });
                  setErrorPhone(false);
                }}
                value={data.phone || ""}
              />
              {errorPhone && <p className="p-danger pb-4">{errorPhone}</p>}
            </div>
            <div>
              <label htmlFor="name">{t("RESERVAR.form.label.name")}</label>
              <input
                className={`${errorName && "input-danger"}`}
                type="text"
                name="nombre"
                placeholder={t("RESERVAR.form.placeholder.name")}
                onChange={(e) => {
                  setData({ ...data, name: e.target.value });
                  setErrorName(false);
                }}
                value={data.name || ""}
              />
              {errorName && <p className="p-danger pb-4">{errorName}</p>}
            </div>
            <div>
              <label htmlFor="userNif">{t("RESERVAR.form.label.nif")}</label>
              <input
                className={`${errorUserNif && "input-danger"}`}
                type="text"
                name="nif"
                placeholder={t("RESERVAR.form.placeholder.nif")}
                onChange={(e) => {
                  setData({ ...data, userNif: e.target.value });
                  setErrorUserNif(false);
                }}
                value={data.userNif || ""}
              />
              {errorUserNif && <p className="p-danger pb-4">{errorUserNif}</p>}
            </div>
          </div>
          <div>
            <div>
              <label htmlFor="observations">
                {t("RESERVAR.form.label.observations")}
              </label>
              <textarea
                name="observaciones"
                id=""
                rows="10"
                resize="none"
                onChange={(e) =>
                  setData({ ...data, observations: e.target.value })
                }
                value={data.observations || ""}
              ></textarea>
            </div>
            <div className="reservar__buttons">
              <div>
                <button
                  className="reservar__btnModificar"
                  onClick={handleBackScreen}
                >
                  {t("RESERVAR.form.buttons.edit")}
                </button>
              </div>
              <div>
                <button
                  disabled={!pagadoChecked}
                  className={`reservar__btnEnviar ${
                    !pagadoChecked && "tabula-tooltip"
                  }`}
                  data-title={t("RESERVAR.form.buttons.tooltip")}
                >
                  {t("RESERVAR.form.buttons.send")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="reservar__conditions">
        <p>
          {t("RESERVAR.terms.desc")}{" "}
          <a
            href={
              language == "cat"
                ? "https://escolaportbarcelona.com/termes-i-condicions/"
                : language == "en"
                ? "https://escolaportbarcelona.com/en/terms-and-conditions/"
                : "https://escolaportbarcelona.com/es/terminos-y-condiciones/"
            }
            target="_blank"
          >
            {t("RESERVAR.terms.link")}
          </a>{" "}
        </p>
      </div>
    </div>
  );
};

export default Reservar;
